// Image protection utilities

/**
 * Prevents common keyboard shortcuts for saving images
 * Call this in useEffect or componentDidMount
 */
export const preventImageDownloadShortcuts = () => {
  const handleKeyDown = (e: KeyboardEvent) => {
    // Prevent Ctrl+S / Cmd+S (Save)
    if ((e.ctrlKey || e.metaKey) && e.key === 's') {
      e.preventDefault();
      return false;
    }

    // Prevent Ctrl+Shift+S / Cmd+Shift+S (Save As)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 's') {
      e.preventDefault();
      return false;
    }

    // Prevent F12 (Developer Tools) - Optional, can be annoying
    // if (e.key === 'F12') {
    //   e.preventDefault();
    //   return false;
    // }

    // Prevent Ctrl+Shift+I / Cmd+Alt+I (Developer Tools) - Optional
    // if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'i') {
    //   e.preventDefault();
    //   return false;
    // }
  };

  document.addEventListener('keydown', handleKeyDown);

  return () => {
    document.removeEventListener('keydown', handleKeyDown);
  };
};

/**
 * Disable right-click on the entire page
 * Use sparingly as it affects user experience
 */
export const disableRightClick = () => {
  const handleContextMenu = (e: MouseEvent) => {
    const target = e.target as HTMLElement;

    // Only disable right-click on images
    if (target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  };

  document.addEventListener('contextmenu', handleContextMenu);

  return () => {
    document.removeEventListener('contextmenu', handleContextMenu);
  };
};

/**
 * Prevent dragging of all images on the page
 */
export const preventImageDrag = () => {
  const handleDragStart = (e: DragEvent) => {
    const target = e.target as HTMLElement;

    if (target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  };

  document.addEventListener('dragstart', handleDragStart);

  return () => {
    document.removeEventListener('dragstart', handleDragStart);
  };
};

/**
 * Initialize all image protection measures
 * Call this once in your main App component
 */
export const initializeImageProtection = () => {
  const cleanupKeyboard = preventImageDownloadShortcuts();
  const cleanupRightClick = disableRightClick();
  const cleanupDrag = preventImageDrag();

  // Return cleanup function
  return () => {
    cleanupKeyboard();
    cleanupRightClick();
    cleanupDrag();
  };
};
